var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.toast)?_c('div',{staticClass:"rd-toast",attrs:{"role":"status"}},[_vm._v(" "+_vm._s(_vm.toast.text)+" "),(_vm.toast.action)?_c('button',{attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('action')}}},[_vm._v(_vm._s(_vm.toast.label))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }